if (!customElements.get('show-stock')) {
  customElements.define(
    'show-stock',
    class ProductOptions extends window.BAO.CustomElement {
      constructor() {
        super()
        this.initialiseShowStock()
      }

      initialiseShowStock() {

        const change = this.handleChange.bind(this)
        // watch for url changes
        let previousUrl = ''
        const observer = new MutationObserver(function(mutations) {
          if (window.location.href !== previousUrl) {
            previousUrl = window.location.href
            const url = window.location.href
            const searchParams = new URLSearchParams(new URL(url).search)
            const variantParam = searchParams.get("variant")

            change(variantParam)
          }
        })

        const config = { subtree: true, childList: true }
        observer.observe(document, config)
      }

      handleChange(variantParam) {

        const generalStock = this.querySelector('.product-inventory')

        if (variantParam != null) {
          if (generalStock) {
            generalStock.classList.remove('stock-msg--show')
          }

          const stockMsgs = this.querySelectorAll('.variant-inventory')
          stockMsgs.forEach(el => el.classList.remove('stock-msg--show'))
          const stockMsg = this.querySelector(`.variant-inventory[data-variant-id="${variantParam}"]`)
          stockMsg.classList.add('stock-msg--show')
        } else {
          generalStock?.classList.add('stock-msg--show')
        }
      }
    }
  )
}